import { useState } from 'react';
import ScrollReveal from '@/components/base/ScrollReveal';

const FORM_URL = 'https://readdy.ai/api/form/d8t5iu0b9jno5e72bhk0';

export default function NewsletterBand() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const WhatsAppNumber = '919686543847';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const honeypot = (e.target as HTMLFormElement).querySelector<HTMLInputElement>('input[name="company_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setSubmitted(true);
      return;
    }
    if (!email.trim()) return;
    setLoading(true);
    try {
      await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });
    } catch {
      // Form submitted best-effort
    }
    setLoading(false);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setEmail('');
    }, 4000);
  };

  return (
    <section className="relative overflow-hidden bg-secondary-200 py-14 md:py-20">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20golden%20hour%20abstract%20light%20and%20soft%20sand%20texture%20background%2C%20dreamy%20warm%20tones%2C%20blurred%20soft%20focus%2C%20elegant%20minimal%20aesthetic%2C%20no%20objects&width=1600&height=600&seq=nl-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative max-w-none mx-auto px-4 md:px-6 text-center">
        <ScrollReveal>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary-500 mb-3">
            Get First Access to New Drops
          </h2>
          <p className="text-sm md:text-base text-foreground-600 font-label mb-7 max-w-md mx-auto">
            Be the first to know about new arrivals, restocks, and exclusive
            offers — straight to your inbox or WhatsApp.
          </p>
        </ScrollReveal>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-lg mx-auto">
          {!submitted ? (
            <form
              onSubmit={handleSubmit}
              data-readdy-form="true"
              className="flex flex-col sm:flex-row items-center gap-3 w-full"
            >
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="contact-alt-field"
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                className="flex-1 w-full sm:w-auto px-5 py-3 text-sm font-label border border-background-300 rounded-full bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                disabled={loading}
                className="px-7 py-3 bg-accent-500 text-primary-800 rounded-full font-heading font-semibold text-sm hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
              >
                {loading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
          ) : (
            <p className="text-accent-600 font-heading font-semibold text-sm md:text-base py-2">
              You&apos;re in! We&apos;ll keep you posted.
            </p>
          )}
        </div>

        <div className="mt-5">
          <span className="text-xs text-foreground-400 font-label">or</span>
        </div>

        <a
          href={`https://wa.me/${WhatsAppNumber}?text=${encodeURIComponent('Hi Joviaa! Please add me to your WhatsApp updates for new drops and offers.')}`}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center gap-2 mt-4 px-7 py-3 bg-primary-500 text-background-50 rounded-full font-heading font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-whatsapp-fill text-base"></i>
          </div>
          Join on WhatsApp
        </a>
      </div>
    </section>
  );
}